export default __webpack_public_path__ + "static/media/gallery_07.6a67c579.jpg";